export const SERVICE = 'VENDORS'

export const PAGE_LIMIT = 10
